<template>
  <div class="vld-parent">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
      :width=128
      :height=128
      :color="indicatorColor"
      background-color="#808080"
    />

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import DeliveryMethods from '../mixins/delivery-methods'

export default {
  data () {
    return {
      isLoading: false,
      fullPage: true,
      indicatorColor: ''
    }
  },
  components: {
    Loading
  },
  methods: {
    doAjax () {
      this.isLoading = true
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false
      }, 5000)
    },
    onCancel () {
      this.isLoading = false
    }
  },
  mounted: function () {
    // インジケーター色をドメインで切り替え
    if (DeliveryMethods.DOMAIN === 0) {
      this.indicatorColor = '#ac1c4c'
    }
    if (DeliveryMethods.DOMAIN === 1) {
      this.indicatorColor = '#000000'
    }
    if (DeliveryMethods.DOMAIN === 2) {
      this.indicatorColor = '#92c5eb'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Indicator.vue